import * as Icons from "lucide-react";
import { SectionHeading } from "./Section";
import { Stagger, StaggerItem } from "./Reveal";
import { WHY_CHOOSE } from "../data/site";

export const WhyChoose = () => (
  <section className="py-24 md:py-32 bg-white" data-testid="why-choose-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading center overline="Why Choose DASH?" title="Care You Can Count On" subtitle="Thoughtful, patient-centered care across physiotherapy, speech and hearing — for children and adults." />
      <Stagger className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {WHY_CHOOSE.map((w) => {
          const Icon = Icons[w.icon] || Icons.CheckCircle;
          return (
            <StaggerItem key={w.title}>
              <div
                data-testid={`why-card-${w.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group h-full rounded-3xl border border-dash-line bg-dash-bg p-7 transition-all duration-400 hover:bg-dash-ink hover:-translate-y-1.5"
              >
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-dash-teal/10 text-dash-teal transition-colors duration-400 group-hover:bg-dash-teal group-hover:text-white">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="mt-5 font-display text-lg font-bold text-dash-ink transition-colors group-hover:text-white">{w.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-dash-muted transition-colors group-hover:text-white/70">{w.desc}</p>
              </div>
            </StaggerItem>
          );
        })}
      </Stagger>
    </div>
  </section>
);
